/* eslint-disable import/no-anonymous-default-export */
export default (institution = [], action) => {
  switch (action.type) {
    case "GET_INSTITUTION":
      return action.payload;
    case "CREATE_INSTITUTION":
      return [...institution, action.payload];
    case "NEW_INSTITUTION_TO_BE_DELETED":
      return institution.filter((data) => data._id !== action.payload);
    default:
      return institution;
  }
};
